export const stateData = [
  {
    key: "1",
    STATENAME: "California",
    IMAGE: "us.png",
    CREATEDDATE: "United States",
    STATUS: "Active",
  },
  {
    key: "2",
    STATENAME: "New York",
    IMAGE: "us.png",
    CREATEDDATE: "United States",
    STATUS: "Inactive",
  },
  {
    key: "3",
    STATENAME: "Texas",
    IMAGE: "us.png",
    CREATEDDATE: "United States",
    STATUS: "Active",
  },
  {
    key: "4",
    STATENAME: "Baveria",
    IMAGE: "de.png",
    CREATEDDATE: "Germany",
    STATUS: "Active",
  },
  {
    key: "5",
    STATENAME: "Quebec",
    IMAGE: "ca.png",
    CREATEDDATE: "Canada",
    STATUS: "Active",
  },
  {
    key: "6",
    STATENAME: "Ontario",
    IMAGE: "ca.png",
    CREATEDDATE: "Canada",
    STATUS: "Inactive",
  },
  {
    key: "7",
    STATENAME: "Florida",
    IMAGE: "us.png",
    CREATEDDATE: "United States",
    STATUS: "Inactive",
  },
  {
    key: "8",
    STATENAME: "Berlin",
    IMAGE: "de.png",
    CREATEDDATE: "Germany",
    STATUS: "Active",
  },
  {
    key: "9",
    STATENAME: "Victoria",
    IMAGE: "au.png",
    CREATEDDATE: "Australia",
    STATUS: "Active",
  },
  {
    key: "10",
    STATENAME: "Gauteng",
    IMAGE: "eg.png",
    CREATEDDATE: "Egypt",
    STATUS: "Active",
  },
];
